const createArraySessionStorage = (me, name) => {
    const _init = function () {
        me.name = name;
        me.store = [];
        _save();
    };

    var _save = function () {
        sessionStorage.setItem(me.name, JSON.stringify(me.store));
    };
    const _addItem = function (item) {
        me.store = JSON.parse(sessionStorage.getItem(me.name));
        me.store.push(item);
        _save();
    };
    const _getItemIndex = function (obj, prop) {
        me.store = JSON.parse(sessionStorage.getItem(me.name));
        return me.store.findIndex((item) => (prop ? item[prop] === obj[prop] : item === obj));
    };

    _init();

    return {
        add: _addItem,
        indexOf: _getItemIndex
    };
}
export default createArraySessionStorage;